module.exports = __webpack_public_path__ + "static/img/14000128.7a6837fc.png";